/* __next_internal_client_entry_do_not_use__ Suspense auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import * as React from "react";
/**
 * Thin wrapper around React.Suspense that omits it when
 * the `unless` prop is true.
 * Primarily needed for SSR compatibility.
 */ export var Suspense = function(props) {
    var isSSR = useIsSSR();
    var _props_unless = props.unless, unless = _props_unless === void 0 ? isSSR : _props_unless, children = props.children, fallback = props.fallback, otherProps = _object_without_properties(props, [
        "unless",
        "children",
        "fallback"
    ]);
    if (unless) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ _jsx(React.Suspense, _object_spread_props(_object_spread({
        fallback: fallback
    }, otherProps), {
        children: children
    }));
};
